export function formatDateLongEs(dateString?: string | null): string | undefined {
	if (!dateString) return undefined;
	const date = new Date(dateString);
	if (isNaN(date.getTime())) return undefined;
	return date.toLocaleDateString('es-ES', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}

export function toISODateOnly(input?: string | Date | null): string {
	if (!input) return '';
	if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}/.test(input)) return input.slice(0, 10);
	const date = input instanceof Date ? input : new Date(input);
	if (isNaN(date.getTime())) return '';
	return date.toISOString().slice(0, 10);
}


